export const lvLV = {
  app: {
    categories: {
      convectors: 'Konvektori',
      decorative: 'Dekoratīvie radiatori',
      electric: 'Elektriskie radiatori',
      panels: 'Paneļu radiatori',
      towel: 'Dvieļu žāvētāji',
    },
    categoryLabel: 'Kategorija',
    categoryPlaceholder: 'Izvēlieties kategoriju',
    errorCategories: 'Neizdevās iegūt kategorijas.',
    errorPanels: 'Neizdevās iegūt radiatorus.',
    loadingCategories: 'Ielādē kategorijas...',
    loadingPanels: 'Ielādē radiatorus...',
    panelLabel: 'Radiatori',
    panelPlaceholder: 'Izvēlieties radiatoru',
    titles: {
      convectors: 'Konvektoru kalkulators',
      decorative: 'Dizaina radiatoru kalkulators',
      electric: 'Elektrisko radiatoru kalkulators',
      panels: 'Paneļu radiatoru kalkulators',
      towel: 'Dvieļu žāvētāju kalkulators',
    },
  },
  calc: {
    actionButton: 'Rādīt aprēķinātos radiatorus',
    boost: 'Boost režīms',
    calculateRequiredButton: 'Aprēķināt siltuma jaudu',
    calculating: 'Aprēķina...',
    comfort: 'Komforta režīms',
    downloadLabel: 'Lejupielādēt datus ({count})',
    emptyResults: 'Nav rezultātu.',
    errorMatch: 'Neizdevās aprēķināt rezultātus.',
    errorTypes: 'Neizdevās iegūt paneļu tipus.',
    flowTemp: 'Padeves temperatūra C°',
    height: 'Augstums',
    length: 'Garums',
    loadingTypes: 'Ielādē tipus...',
    modeLabel: 'Režīms',
    modes: {
      cooling: 'Dzesēšana',
      heating: 'Siltums',
    },
    radiatorType: 'Radiatora tips',
    requiredWatts: 'Nepieciešamā jauda (W)',
    resultsMessage: '{count} pozīcijas pieejamas ar izvēlētajām opcijām.',
    returnTemp: 'Atgaitas temperatūra C°',
    roomTemp: 'Istabas temperatūra C°',
    selectAllLabel: 'Izvēlēties visas pozīcijas',
    selectItemLabel: 'Izvēlieties pozīcijas lejupielādei',
    selectPanel: 'Izvēlieties radiatoru aprēķinam.',
    standby: 'Gaidīšanas režīms',
    tableHeaders: {
      calculatedWattage: 'Jauda',
      co2Equivalent: 'CO2 ekvivalents uz kg materiāla',
      depth: 'Dziļums [mm]',
      description: 'Preces apraksts',
      dop: 'DOP',
      eudop: 'EU DOP',
      height: 'Augstums [mm]',
      itemId: 'Preces kods',
      length: 'Garums [mm]',
      waterContent: 'Ūdens tilpums',
      weight: 'Svars',
    },
    title: 'Aprēķini',
    tolerance: 'Tolerance',
    typeCooling: 'Dzesēšana',
    typeGroupLabel: 'Tips',
    typeHeating: 'Apkure',
  },
  existingRadiator: {
    description:
      'Šis kalkulators ir paredzēts tikai informatīviem nolūkiem. Vienmēr konsultējieties ar profesionālu uzstādītāju, lai iegūtu precīzu aprēķinu pirms radiatora iegādes.',
    height: 'Radiatora augstums',
    length: 'Radiatora garums',
    resultLabelTemplate: 'Siltuma jaudas vajadzība, aprēķināta ar sistēmas temperatūru {temp}',
    select: 'Izvēlēties',
    temperature: 'Sistēmas temperatūra',
    type: 'Radiatora tips',
  },
  matrixCalc: {
    axisHeight: 'Augstums (mm)',
    axisLength: 'Garums (mm)',
    axisType: 'Tips',
    calculateButton: 'Calculate',
    displayLabel: 'Attēlojums',
    exportExcel: 'Eksportēt uz Excel',
    exportPdf: 'Eksportēt uz PDF',
    print: 'Drukāt',
    hideOutOfRange: 'Paslēpt vienumus ārpus diapazona',
    showAll: 'Rādīt visu',
    loading: 'Loading...',
    lockHeight: 'Augstums',
    lockLabel: 'Fiksēt izmēru',
    lockLength: 'Garums',
    lockType: 'Tips',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Aprēķināt',
    clearButton: 'Notīrīt',
    fields: {
      ceilingHeight: 'Griestu augstums',
      doorInsulation: 'Durvju siltumizolācija',
      floorInsulation: 'Grīdas siltumizolācija',
      glazingArea: 'Stiklojuma laukums',
      glazingMode: 'Stiklojuma laukums',
      glazingQuality: 'Stiklojuma kvalitāte',
      length: 'Garums',
      outerWalls: 'Ārsienas',
      projectedDesignTemp: 'Projektētā āra temperatūra',
      roofInsulation: 'Jumta siltumizolācija',
      roomArea: 'Telpas platība',
      roomFloor: 'Stāvs',
      roomInsulation: 'Telpas siltumizolācija',
      roomPreset: 'Telpas tips',
      roomTemperature: 'Telpas temperatūra',
      roomType: 'Telpas veids',
      uncertaintyFactor: 'Nenoteiktības faktors',
      ventilation: 'Ventilācijas līmenis',
      wallInsulation: 'Sienu siltumizolācija',
      width: 'Platums',
      windConditions: 'Vēja apstākļi',
      windowInsulation: 'Logu siltumizolācija',
    },
    intro:
      'Aprēķiniet telpas siltuma zudumus, lai atrastu piemērotāko radiatoru no Purmo sortimenta.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Vairāk nekā 20%',
        low: 'Mazāk nekā 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Virs 20%',
        below_10: 'Zem 10%',
        from_10_to_20: 'No 10% līdz 20%',
        no_windows: 'Nav logu',
      },
      insulationValue: {
        good: 'Labs',
        medium: 'Vidējs',
        poor: 'Vājš',
        very_good: 'Ļoti labs',
      },
      qualityValue: {
        modern_excellent: 'Energoefektīvi, trīskāršs stikls',
        modern_good: 'Moderni, blīvi, ar izolācijas stiklu',
        old_poor: 'Veci, nolietoti, neblīvi',
        traditional_medium: 'Tradicionāli labā stāvoklī, papildu blīvēti',
      },
      roomValue: {
        bathroom_24: 'Vannas istaba (24 C°)',
        bedroom_20: 'Guļamistaba (20 C°)',
        garage_12: 'Garāža (12 C°)',
        livingroom_22: 'Dzīvojamā istaba (22 C°)',
        storage_16: 'Noliktava (16 C°)',
        extra_1: 'Gaitenis (18 C°)',
      },
      select: 'Izvēlēties',
      storeyValue: {
        ground_multi: 'Pirmais stāvs (daudzstāvu ēka)',
        ground_single: 'Pirmais stāvs (vienstāva ēka)',
        interim: 'Vidējais stāvs',
        top_multi: 'Augšējais stāvs (daudzstāvu ēka)',
      },
      temp: {
        climate_zone_1: 'Piekrastes zona -18 C°',
        climate_zone_2: 'Centrālā Latvija -20 C°',
        climate_zone_3: 'Austrumlatvija -22 C°',
        climate_zone_4: 'Vidzemes augstiene -24 C°',
      },
      windInfluence: {
        normal: 'Normāls',
        strong: 'Stiprs',
        weak: 'Labvēlīgi',
      },
    },
    roomPresets: {
      bathroom: 'Vannas istaba',
      bedroom: 'Guļamistaba',
      garage: 'Garāža',
      kitchen: 'Virtuve',
      living: 'Dzīvojamā istaba',
      storage: 'Noliktava',
    },
    sections: {
      dimensions: 'Telpas izmēri',
      insulation: 'Siltumizolācija',
      placement: 'Izvietojums',
      result: 'Rezultāti',
      temps: 'Temperatūras',
      ventilation: 'Ventilācija',
    },
    title: 'Telpas siltuma zudumu kalkulators',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Izmantot',
  },
  slider: {
    from: 'No',
    to: 'Līdz',
    value: 'Vērtība',
  },
}
